import { Link, useSearchParams  } from "react-router-dom";
import React, { useEffect, useState } from "react";
export default function NotSigninPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const errorRes = searchParams.get("errorRes");
    if (errorRes) {
      setError(errorRes);
    }
  }, [searchParams]);

  return (
    <div id="error-page" className="p-8 ">
      <h1>Oops!</h1>
      <p>您尚未登入.</p>
      {error && (
        <p className="text-red-500 whitespace-pre-wrap">錯誤訊息: {decodeURIComponent(error)}</p>
      )}
      <p>
        請前往 <Link to="https://1campus.net"> 1campus.net </Link> 登入。
      </p>
    </div>
  );
}